import React from 'react';
import { TableCell, TableRow } from '@amzn/meridian/table';
import { useTranslation } from 'src/arb-wrapper';

interface NoResultsTableRowProps {
  /** The number of cells in the row to span. */
  span: number;
}

/** Utility to display a common message for an empty Meridian `Table`. */
export const NoResultsTableRow: React.FC<NoResultsTableRowProps> = ({
  span,
}) => {
  const { t } = useTranslation();

  return (
    <TableRow key="empty-row">
      <TableCell columnSpan={span}>{t('table_no_results')}</TableCell>
    </TableRow>
  );
};
